import React from 'react'
import { useTranslation } from 'react-i18next'
import { Banner } from '@node-space/storybook-components/dist/Banner'
import { Box, Icon } from '@node-space/ui-components'

export const SuspendedAccountBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner
      key="suspendedAccountBanner"
      message={
        <Box tag="span" flex gapX={8}>
          <Icon name="Info" />
          <span>{t('suspendedAccountBanner')}</span>
        </Box>
      }
      state="info"
    />
  )
}
